var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1.09961 8.7H7.49961C7.89961 8.7 8.29961 9 8.39961 9.4C8.79961 11.4 10.6996 12.6 12.6996 12.2C14.0996 11.9 15.1996 10.8 15.4996 9.4C15.5996 9 15.9996 8.7 16.3996 8.7H22.7996V3.3C22.7996 2.3 21.9996 1.5 20.9996 1.5H2.89961C1.89961 1.5 1.09961 2.3 1.09961 3.3V8.7Z",
    fill: "#7FBB51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89961 1.40039H20.9996C21.9996 1.40039 22.7996 2.20039 22.7996 3.20039V15.9004C22.7996 16.9004 21.9996 17.7004 20.9996 17.7004H2.89961C1.89961 17.7004 1.09961 16.9004 1.09961 15.9004V3.20039C1.09961 2.20039 1.89961 1.40039 2.89961 1.40039Z",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09961 8.7002H7.49961C7.89961 8.7002 8.29961 9.0002 8.39961 9.4002C8.79961 11.4002 10.6996 12.6002 12.6996 12.2002C14.0996 11.9002 15.1996 10.8002 15.4996 9.4002C15.5996 9.0002 15.9996 8.7002 16.3996 8.7002H22.7996",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09961 5H22.7996",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageCard);
export default __webpack_public_path__ + "static/media/manage-card.99980d241ded1b57fcccd831bd95ee32.svg";
export { ForwardRef as ReactComponent };